import type {Pagination} from '../../../Data/types/BaseResponse';
import {MarketerTrackingRepositoryImpl} from '../repository/MarketerTrackingRepositoryImpl';
import type {SessionFilters, WorkSession} from '../models/session.model';

export interface GetSessionsListResult {
  sessions: WorkSession[];
  pagination: Pagination;
}

export class GetSessionsListUseCase {
  private readonly repository = new MarketerTrackingRepositoryImpl();

  async execute (filters: SessionFilters = {}): Promise<GetSessionsListResult> {
    return this.repository.getSessions(filters);
  }
}
